import { colord, getFormat } from 'colord'

export const hexToRGBA = (hex: string, alpha: number) => {
  if (getFormat(hex) !== 'hex') {
    throw new Error('Invalid HEX')
  }
  const color = colord(hex)
  return color.alpha(alpha).toRgbString()
}
